import { render, staticRenderFns } from "./navigation-sidebar.vue?vue&type=template&id=0fb2677e&scoped=true&"
import script from "./navigation-sidebar.vue?vue&type=script&lang=js&"
export * from "./navigation-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb2677e",
  null
  
)

export default component.exports